import { render } from "./ReferralClient.vue?vue&type=template&id=e8798ef0&scoped=true"
import script from "./ReferralClient.vue?vue&type=script&lang=js"
export * from "./ReferralClient.vue?vue&type=script&lang=js"

import "./ReferralClient.vue?vue&type=style&index=0&id=e8798ef0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8798ef0"]])

export default __exports__